import React from "react";
import { useContent } from "../../content/ContentContext";

export const SocialProofBar = () => {
  const c = useContent("social_proof");
  const orgs = Array.isArray(c.orgs) ? c.orgs : [];
  return (
    <section data-testid="social-proof-bar" aria-label="Organisations Rochelle has worked with" className="pt-2 md:pt-4">
      <div className="sc-container">
        <div className="flex flex-col items-center text-center">
          <span className="text-[11px] uppercase tracking-[0.28em] text-muteink/80 font-body font-medium">
            {c.label}
          </span>
          <p className="mt-4 font-serif italic text-ink2 text-base md:text-[1.1rem] leading-relaxed max-w-3xl flex flex-wrap items-center justify-center gap-x-2 md:gap-x-3 gap-y-1.5">
            {orgs.map((o, i) => (
              <span key={`${o}-${i}`} className="inline-flex items-center gap-x-2 md:gap-x-3">
                <span className="whitespace-nowrap">{o}</span>
                {i < orgs.length - 1 && <span aria-hidden="true" className="text-gold/80">·</span>}
              </span>
            ))}
          </p>
        </div>
      </div>
    </section>
  );
};

export default SocialProofBar;
